import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { Icon } from '../icon/Icon';
import { ICON_NAMES } from '../icon/icon.helper';
import { style } from './CheckBox.style';
import { neutrals } from 'src/theme/colors';
import { BaseButton } from '../buttons/base-button/BaseButton';
import { TBaseButtonProps } from '../buttons/base-button/BaseButton.types';

type CheckBoxProps = {
  onPress: () => void;
  isChecked: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
} & Pick<TBaseButtonProps, 'accessibilityLabel' | 'testID' | 'focusId' | 'focusGroup' | 'focusOrder'>;

export const CheckBox = observer(
  ({
    onPress,
    isChecked,
    onMouseEnter,
    onMouseLeave,
    testID,
    accessibilityLabel,
    focusGroup,
    focusOrder,
    focusId,
  }: CheckBoxProps) => {
    return (
      <BaseButton
        testID={testID}
        focusId={focusId ?? testID}
        focusOrder={focusOrder}
        focusGroup={focusGroup}
        style={[style.checkbox, isChecked && style.checkboxActive]}
        onPress={async () => onPress()}
        onHoverIn={onMouseEnter}
        onHoverOut={onMouseLeave}
        accessibilityRole="checkbox"
        accessibilityLabel={accessibilityLabel}
        accessibilityState={{ checked: isChecked }}
      >
        {() => (
          <>
            {isChecked && (
              <View style={style.iconCheck}>
                <Icon name={ICON_NAMES.Check} color={neutrals.white} />
              </View>
            )}
          </>
        )}
      </BaseButton>
    );
  },
);
